import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

export const fetchPrograms = async () => {
  const { data } = await api.get("/programs");
  return data;
};

export const fetchProgram = async (slug) => {
  const { data } = await api.get(`/programs/${slug}`);
  return data;
};

export const fetchFaculty = async () => {
  const { data } = await api.get("/faculty");
  return data;
};

export const fetchNews = async () => {
  const { data } = await api.get("/news");
  return data;
};

export const submitContact = async (payload) => {
  const { data } = await api.post("/contact", payload);
  return data;
};
